var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRightBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.707 8.704c.39-.39.39-1.025 0-1.416l-6-6a1.002 1.002 0 0 0-1.416 1.416l5.294 5.294-5.29 5.293a1.002 1.002 0 0 0 1.415 1.416l6-6-.003-.003Z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.471 8.47a.668.668 0 0 0 0-.944l-4-4a.668.668 0 0 0-.944.943L9.057 8 5.53 11.527a.668.668 0 0 0 .943.943l4-4-.002-.002Z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightBlack);
export default __webpack_public_path__ + "static/media/arrow-right-black.944c6ab5dfa82413ea04b6aa5b2666bd.svg";
export { ForwardRef as ReactComponent };